import React from 'react';

const STATUS_CONFIG = {
  sent: {
    label: 'Enviada',
    icon: '✅',
    bg: '#f0faf3',
    color: '#1a5c2e',
    border: '#86c49f',
  },
  draft: {
    label: 'Borrador',
    icon: '💾',
    bg: '#fef3c7',
    color: '#92400e',
    border: '#fcd34d',
  },
  archived: {
    label: 'Archivada',
    icon: '📦',
    bg: '#f3f4f6',
    color: '#4b5563',
    border: '#d1d5db',
  },
};

/**
 * Badge visual claro del estado de un onboarding (sent / draft / archived).
 *
 * Diseñado para máxima visibilidad en tableros colaborativos:
 * cualquier miembro del equipo puede identificar el estado real de un alta
 * de un solo vistazo.
 *
 * @param {string} status  Uno de: 'sent', 'draft', 'archived' (fallback: muestra el valor literal)
 */
export function OnboardingStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Sin estado',
    icon: '•',
    bg: '#f3f4f6',
    color: '#4b5563',
    border: '#d1d5db',
  };

  return (
    <span
      data-testid={`onboarding-status-badge-${status || 'unknown'}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: config.bg,
        color: config.color,
        border: `1px solid ${config.border}`,
        borderRadius: '6px',
        padding: '4px 10px',
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        whiteSpace: 'nowrap',
      }}
    >
      <span>{config.icon}</span> {config.label}
    </span>
  );
}

export default OnboardingStatusBadge;
